__turbopack_context__.v({
  "assistant-upload-progress": "_8EHURa_assistant-upload-progress",
  "assistantMessage": "_8EHURa_assistantMessage",
  "attachmentChip": "_8EHURa_attachmentChip",
  "attachmentIcon": "_8EHURa_attachmentIcon",
  "attachmentPreview": "_8EHURa_attachmentPreview",
  "attachmentPreviewStatus": "_8EHURa_attachmentPreviewStatus",
  "attachmentProgress": "_8EHURa_attachmentProgress",
  "composer": "_8EHURa_composer",
  "composerInput": "_8EHURa_composerInput",
  "composerInputCompact": "_8EHURa_composerInputCompact",
  "dropOverlay": "_8EHURa_dropOverlay",
  "hasFeedback": "_8EHURa_hasFeedback",
  "mobileTouchTarget": "_8EHURa_mobileTouchTarget",
  "thinkingToggle": "_8EHURa_thinkingToggle",
  "workSummaryToggle": "_8EHURa_workSummaryToggle",
});
